import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSelectInput} from "../abstract-select-input";
import {FUIEventsService} from "../../../../events/events.service";import {FUIOptionsService} from "../../../framework/options.service";
import {PopParentVerticalAlignment} from "../../../../pops/abstract-pop";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineSelectInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-select-input",
    styleUrls: ["../select-input.scss"],
    templateUrl: "./inline-select-input.component.html"
})
export class FUIInlineSelectInputComponent extends FUIAbstractSelectInput {
    validationErrorVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.ABOVE;

    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(elementRef,changeDetectorRef, eventsService, optionsService);
    }

    optionsVerticalAligmnment(alignment: PopParentVerticalAlignment): void {
        this.validationErrorVerticalAlignment = alignment === PopParentVerticalAlignment.ABOVE ? PopParentVerticalAlignment.BELOW : PopParentVerticalAlignment.ABOVE;
    }
}
